import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './components/aboutPage/AboutUs';
import TermsConditions from './components/termsconditions/TermsConditions';
import PrivacyPolicy from './components/privacypolicyPage/PrivacyPolicy';
import ContactUs from './components/contactuspage/ContactUs';

function App() {
  return (
    <div className='App'>

      <Routes>
        <Route path="/" element={ <Home/> } />
        <Route path="about" element={ <AboutUs/> } />
        <Route path="privacy-policy" element={ <PrivacyPolicy/> } />
        <Route path="terms-conditions" element={ <TermsConditions/> } />
        <Route path="contact-us" element={ <ContactUs/> } />
      </Routes>
    

    </div>
  );
}

export default App;
